<template>
<main>
<v-container class="grey lighten-4 fill-height">
  <v-row>
            <v-col class="mx-auto" >
              <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <!-- <v-toolbar-title>Dina möten</v-toolbar-title> -->
                  <v-tabs
    grow
    dark
  >
    <v-tab @click="outgoing">
      Möten du är administratör för
    </v-tab>
    <v-tab @click="incoming">
      Möten där du svarat
    </v-tab>
  </v-tabs>
                </v-toolbar>
                <v-card-text>
  <v-data-table
  v-if="outtab == true"
    :headers="headers"
    :items="schedule"
    :items-per-page="10"
    no-data-text="Ingen data tillgänglig"
    :footer-props="{
    'items-per-page-text': 'Rader per sida:',
    'items-per-page-all-text': 'Allt',
    }"
    class="elevation-1"
  >
    <template v-slot:item.title="{ item }">
      <router-link :to="'/schedule/'+item.schedule_link">{{ item.title }}</router-link>
    </template>
  <template v-slot:item.status="{ item }">
      <v-chip :color="new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'green':'red'" dark>
        {{ new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'öppen':'stängd' }}
        </v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?item.reply_deadline_date:'Ingen tidsfrist' }}
    </template>
    <template v-slot:item.id="{ item }">
      <v-btn :to="'/account/participants/'+item.id" v-show="item.participant_count > 0"><v-icon  
                    >fas fa-external-link-alt</v-icon></v-btn>
    </template>
    <template v-slot:item.user_id="{ item }">
      <v-btn :to="'/updateschedule/'+item.id"><v-icon  
                    >fas fa-cog</v-icon></v-btn>
    </template>
    <template v-slot:footer.page-text="items">
       {{ items.pageStart }} - {{ items.pageStop }} av {{ items.itemsLength }} 
       </template>
  </v-data-table>
  <v-data-table
  v-if="outtab == false"
    :headers="inheaders"
    :items="schedule"
    :items-per-page="10"
    no-data-text="Ingen data tillgänglig"
    :footer-props="{
    'items-per-page-text': 'Rader per sida:',
    'items-per-page-all-text': 'Allt',
    }"
    class="elevation-1"
  >
    <template v-slot:item.title="{ item }">
      <router-link :to="'/schedule/'+item.schedule_link">{{ item.title }}</router-link>
    </template>
  <template v-slot:item.status="{ item }">
      <v-chip :color="new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'green':'red'" dark>
        {{ new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'öppen':'stängd' }}
        </v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?item.reply_deadline_date:'Ingen tidsfrist' }}
    </template>
  </v-data-table>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
  </v-container>
  </main>
</template>


<script>
import store from "../../../store";
import axios from "axios";
  export default {
    data () {
      return {
        store: store,
        headers: [
          {
            text: 'Titel',
            align: 'start',
            sortable: false,
            value: 'title',
          },
          { text: 'Antal svar', value: 'participant_count' },
          { text: 'Status', value: 'status' },
          { text: 'Tidsfrist', value: 'reply_deadline_date' },
          { text: 'Deltagare', value: 'id' },
          { text: 'Inställningar', value: 'user_id' },
        ],
        inheaders: [
          {
            text: 'Titel',
            align: 'start',
            sortable: false,
            value: 'title',
          },
          { text: 'Status', value: 'status' },
          { text: 'Tidsfrist', value: 'reply_deadline_date' },
        ],
        intab: false,
        outtab: true,
        schedule: [],
        today:new Date().setHours(0,0,0,0)
      }
    },
    created: async function() {
        this.outgoing()
    },
    methods: {
      getColor (status) {
        if (status === 'yes') return 'green'
        else return 'red'
      },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
    async outgoing () {
      this.outtab = true
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}outgoingschedules/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule;
        // console.log(new Date(this.schedule[0].reply_deadline_date).setHours(0,0,0,0))
    },
    async incoming () {
      this.outtab = false
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}incomingschedules/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule;
        // console.log(new Date(this.schedule[0].reply_deadline_date).setHours(0,0,0,0))
    }
    },
  }
</script>